<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];

	const content = configs
		.map((config) => config.values.javascript)
		.join(';')
		.replaceAll('\n', ';');

	onMount(() => {
		const customJs = document.getElementById('customJs');
		if (customJs) {
			customJs.innerText = content;
		}
	});
</script>

<svelte:head>
	<script defer id="customJs"></script>
</svelte:head>
